import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { useCache } from 'global/cnr/contexts/useHelpers/useCache';
import QrScan from 'global/pageItem/modification/pageItemActions/QrScan';
import _ from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Icon, Menu } from 'semantic-ui-react';
import { sendFcmMessage } from '../../../projectSpecific/sports/cnr/reducers/SportsDataReducer';
import AppNotificationsManager, { appNotificationTypes } from '../../appNotifications/AppNotificationsManager';
import { FrameworkContext } from '../../cnr/contexts/FrameworkContent';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { _currentUserIdProp } from '../../cnr/reducers/AppUserReducer';
import { _appSidebarContentTypes } from '../../cnr/reducers/FrameworkReducer';
import { uniqueKey } from '../../common/keys';
import { gEnums } from '../../enums/globalEnums';
import { buildFcmPayload } from '../../functions/fbNotifications';
import { currentHelpers } from '../../redirection/current';
import { _fcmTopicKeys, useFcm } from 'global/cnr/contexts/useHelpers/useFcm';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';

const localOpts = {
  allowCookieClearing: true
}

const NavSideBottomMenu = (props) => {

  const _host = document.location.host

  // parentContext
  const parentContext = useContext(ParentContext);
  const { settings, states, handlers, fns, navigate, fn_cls } = parentContext ?? {}
  const { app_state, appSettings_state, appUser_state, currentSettings_state, paps_state, serviceWorker_state, storage_state } = states ?? {}
  const { appSettings_handlers, serviceWorker_handlers, appUsers_handlers } = handlers ?? {}
  const { currentAppVersion, newVersionAvailable } = serviceWorker_state ?? {}
  const { notificationRequestGranted } = appUser_state ?? {}
  const appUserAccess = useAppUserAccess()
  const { email, fcmTokens, isSuperAdminDeveloper } = appUserAccess ?? {}
  const { appConfigSettings, toggleDeviceOn } = appSettings_state ?? {}
  const { appNames, isMeProd } = appConfigSettings ?? {}
  const { appNameSc } = appNames ?? {}
  const { app_metas } = app_state ?? {}

  const cacheProps = useCache()

  const platform = _.get(app_state, 'currentEnvironment.platform', null)
  const fcmType = _.get(app_state, 'currentEnvironment.platform.fcmType', false)
  const os = _.get(app_state, 'currentEnvironment.os', null)

  const isMeAuth = _.includes(app_metas?.projectId, 'me-') ? true : false

  const { homeSettings } = settings ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}

  const { page_fns } = fns ?? {}

  const { allowSidebarView } = props

  const _appVersion = isMeProd ? currentAppVersion : currentAppVersion + '*'

  // papsContext 
  const { pathViews, rootPaths, pathname } = paps_state ?? {}

  const _fcmToken = fcmTokens && fcmType ? fcmTokens[fcmType] : null

  const { clients: clientKey, events: eventKey } = pathViews ?? {}

  // pageContext  
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { eventOptions, clientOptions, appNotifications, styles, appInstallation, sideMenu } = aps_global ?? {}

  const { allowNotifications } = appNotifications ?? {}
  const { sideMenus } = styles ?? {}
  const { iconsLeft } = sideMenu ?? {}
  const _appOptions = { ...clientOptions, ...eventOptions }
  const {
    allowBackToClient,
    allowCookieClearing,
    allowNotificationCheck,
    allowPermissionsReset,
    allowSendUserId,
    allowAppLinkSharing,
    helpPdf,
    showHelp,
    showLyft,
    showQrCode,
    showUber,
    showUserImage,
    showWeather,
    showWifi,
    useOptionsDropdown,
    weatherCountryCode,
    weatherZip,
    wifiNetwork,
    wifiPassword,
  } = _appOptions ?? {}

  const _allowCookieClearing = allowCookieClearing || localOpts.allowCookieClearing

  const { allowAppInstallation, allowAutoPromptForAppIntallation, allowManualAppInstallation, showAddToHomeScreenHelp } = appInstallation ?? {}

  const { appUrls: homeAppUrls } = homeSettings_global ?? {}
  const { appUrls: appUrlz } = homeAppUrls ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { isMobileDevice } = framework_state ?? {}

  const [showNotifications, setShowNotifications] = useState()
  const [helpUrl, setHelpUrl] = useState()
  const [showStaticMis, setShowStaticMis] = useState()
  const [showFcm, setShowFcm] = useState()
  const [showScanner, setShowScanner] = useState()

  const { sendFcm_toToken } = useFcm()

  useEffect(() => {
    const { appStorageUrlFiles } = storage_state ?? {}
    const { pdf } = appStorageUrlFiles ?? {}
    const _helpPdf = pdf && pdf[helpPdf]
    const { urls } = _helpPdf ?? {}
    const { full } = urls ?? {}
    setHelpUrl(full)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const textAreaRef = useRef()

  const handleShowHelp = () => window.open(helpUrl, '_blank')

  const handleBackToClient = () => {
    if (rootPaths && rootPaths.clients) {
      const pn = rootPaths.clients.substring(0, rootPaths.clients.length - 1)
      navigate(pn)
    }
  }

  const handleBackToHome = () => {
    if (rootPaths && rootPaths.clients) {
      const pn = rootPaths.clients.substring(0, rootPaths.clients.length - 1)
      navigate('/')
    }
  }

  // FrZi8TCLcOSTKr8L2n5s 
  // const handleShare = () => copyCodeToClipboard(textAreaRef)
  const handleAppSharing = () => framework_handlers.handleShow_appSidebarContent(_appSidebarContentTypes.appSharing)
  const handleShowWifi = () => framework_handlers.handleShow_appSidebarContent(_appSidebarContentTypes.wifi)
  const handleShowNotificationCheck = () => framework_handlers.handleShow_appSidebarContent(_appSidebarContentTypes.notificationCheck)
  const handleShowStaticMis = () => setShowStaticMis(!showStaticMis)

  const handleAddToTopic = () => fn_cls.subscribeToTopic(_fcmToken, _fcmTopicKeys.generic)

  const handleFcmTest = (tk) => {
    sendFcm_toToken(tk, 'Self Test', 'This is just a test')
  }

  const handleToggle_device = () => appSettings_handlers.handleToggle_device()

  const handleClearCookies = () => {
    localStorage.clear()
    cacheProps.clearAllCache()
    framework_handlers.handleShow_appSidebar()
  }

  const handleResetPermissions = () => {
    if ('Notification' in window) {
      Notification.requestPermission().then(permission => {
        console.log('Notification permission reset to:', permission);
      });
    }
  }

  const handleSendUserId = () => {
    const _currentUserId = currentHelpers.storageItem_get(_currentUserIdProp)
    if (_currentUserId) {
      sendFcmMessage(_currentUserId)
    }
  }

  const handleShowHomeScreenPrompt = () => {
    const addToHomeScreenItem = eventKey ? 'appInstallation-' + eventKey : 'appInstallation'
    // remove the item first
    window.localStorage.removeItem(addToHomeScreenItem)
    appSettings_handlers.handleShow_homeScreenPrompt(true)
    framework_handlers.handleShow_appSidebar()
  }

  const handleShowHomeScreenHelpPrompt = () => {
    appSettings_handlers.handleShowHomeScreenHelp()
    framework_handlers.handleShow_appSidebar()
  }

  const handleShowScanner = () => setShowScanner(!showScanner)

  const handleNotifications = () => {
    !showNotifications && framework_handlers.handleShow_appSidebar()
    setShowNotifications(!showNotifications)
  }

  const handleGetLatest = () => serviceWorker_handlers.handleClear_refresh()
  const handleShowFcm = () => setShowFcm(!showFcm)
  const handleLinkClick = (url) => { window.open(url, '_blank') }

  const lyftLink = page_fns.getLink(appUrlz, 'lyft', isMobileDevice)
  const uberLink = page_fns.getLink(appUrlz, 'uber', isMobileDevice)
  const weatherLink = page_fns.getLink(appUrlz, 'weather', isMobileDevice)

  const _shows_nav = {
    homescreenHelp: showAddToHomeScreenHelp,
    installation: allowAppInstallation && allowManualAppInstallation,
    appLinkSharing: allowAppLinkSharing,
    lyft: showLyft && lyftLink,
    notifications: allowNotifications,
    uber: showUber && uberLink,
    userQrOrImage: showQrCode || showUserImage,
    weather: showWeather && weatherLink && weatherZip,
    wifi: showWifi && wifiNetwork && wifiPassword
  }

  const getItemStyle = () => {
    const miStyle = {
      paddingTop: sideMenus && sideMenus.apply && sideMenus.padding ? sideMenus.padding + 'em' : null,
      paddingBottom: sideMenus && sideMenus.apply && sideMenus.padding ? sideMenus.padding + 'em' : null,
      fontSize: sideMenus && sideMenus.fontSize && sideMenus.fontSize ? sideMenus.fontSize + 'em' : null,
    }
    return miStyle
  }

  const menuIcon = (name, oc, color) => <Icon size='large' key={uniqueKey('nvsm', _.camelCase(name))} name={name} color={color} onClick={() => oc && oc()} />

  const linkMenuItem = (caption, url, replace, replaceWith, icon) => {
    const sty = getItemStyle()
    let itemCaption = _.startCase(caption)
    if (replace && replaceWith) {
      url = url.replace(replace, replaceWith)
      if (weatherCountryCode) { url = url.replace('US', weatherCountryCode) }
      itemCaption += ' (' + replaceWith + ')'
    }
    return <Menu.Item key={uniqueKey('nbsm', caption)} style={sty} onClick={() => handleLinkClick(url)}>{itemCaption}{menuIcon(icon)}</Menu.Item>
  }

  const menuItem = (text, sty, icon, oc) => <Menu.Item style={sty} onClick={() => oc()}>{menuIcon(icon)}{text}</Menu.Item>
  const menuItemIcon = (text, sty, icon, oc, color) => <Menu.Item style={sty} onClick={() => oc && oc()}>{menuIcon(icon, oc, color)}{text}</Menu.Item>

  const menuItemIcons = (text, sty, icons, oc, color) => {
    const _icons = []
    icons.forEach(i => {
      _icons.push(menuIcon(i.name, i.oc, i.color))
    })
    return <Menu.Item style={sty}>{_icons}{text}</Menu.Item>
  }

  const menuItemFcm_subscribe = (sty) => <Menu.Item
    style={sty}
    className='fcmt'
    onClick={() => isSuperAdminDeveloper && handleAddToTopic()}
  >{_fcmToken.tokenKey.substring(0, 40) + '...'}
  </Menu.Item>

  const menuItemFcm_test = (sty) => <Menu.Item
    style={sty}
    className='fcmt'
    onClick={() => isSuperAdminDeveloper && handleFcmTest(_fcmToken.tokenKey)}
  >{'Send Test Notification to Self (' + fcmType + ')'}
  </Menu.Item>

  const menuItems_nav = () => {
    const sty = getItemStyle()
    const _navItems = []
    if (_shows_nav.wifi) { _navItems.push(menuItem('Wifi', sty, 'wifi', handleShowWifi)) }
    if (_shows_nav.notifications) { _navItems.push(menuItem('Notifications', sty, 'bell outline', handleNotifications)) }
    if (_shows_nav.appLinkSharing) { _navItems.push(menuItemIcon('App Sharing', sty, 'qrcode', handleAppSharing, 'blue')) }
    if (_shows_nav.lyft) { _navItems.push(linkMenuItem('lyft', lyftLink, null, null, 'lyft')) }
    if (_shows_nav.uber) { _navItems.push(linkMenuItem('uber', uberLink, null, null, 'uber')) }
    if (_shows_nav.weather) { _navItems.push(linkMenuItem('weather', weatherLink, 'ZIPCODE', weatherZip, 'cloud')) }
    if (_shows_nav.installation) { _navItems.push(menuItem('Add to Home Screen', sty, 'home', handleShowHomeScreenPrompt)) }
    if (_shows_nav.homescreenHelp) { _navItems.push(menuItem('Add to Home Screen Instructions', sty, 'help', handleShowHomeScreenHelpPrompt)) }
    return _navItems
  }

  const menuItems_device = () => {

    const sty = getItemStyle()
    const _navItems = []

    let _tokenColor = 'grey'
    if (_fcmToken) {
      if (notificationRequestGranted) {
        _tokenColor = 'green'
      } else {
        _tokenColor = 'blue'
      }
    }

    const manifestInfo = localStorage.getItem("manifestInfo");
    const _manifestInfo = manifestInfo ? JSON.parse(manifestInfo) : {}
    const { source, manifestKey, manifest } = _manifestInfo ?? {}
    const { start_url } = manifest ?? {}
    const start_url_hashed = start_url && start_url.includes('#') ? true : false

    const _icons_refresh = []
    const _icons_platform = []
    const _icons_os = []
    const _icons_manifest = []

    _icons_refresh.push({ name: 'refresh', oc: handleGetLatest, color: newVersionAvailable ? 'green' : 'blue' })
    _icons_platform.push({ name: platform?.icon, oc: _fcmToken ? handleShowFcm : null, color: _tokenColor })

    let manifestIcon = start_url_hashed ? 'check circle outline' : 'circle outline'
    let manifestColor = source === 'cache' ? 'green' : 'blue'
    if (!start_url_hashed) { manifestColor = 'grey' }
    if (manifestKey !== clientKey && manifestKey !== eventKey) { manifestColor = 'teal' }
    _icons_manifest.push({ name: manifestIcon, color: manifestColor })
    if (platform?.device === 'desktop') {
      _icons_platform.push({ name: 'desktop', oc: handleToggle_device, color: toggleDeviceOn ? 'blue' : 'grey' })
    }

    let _os;

    if (os?.name) {
      if (os?.name) {
        _icons_os.push({ name: 'info circle' })
      }
      _os = os.name + ': ' + os?.version
    }

    if (_os) {
      _navItems.push(menuItemIcons('OS: ' + _os, sty, _icons_os))
    }

    _navItems.push(menuItemIcon(email ? email : 'Not logged in', sty, isMeAuth ? 'user circle' : 'user circle outline', null, isMeAuth ? 'blue' : 'teal'))
    _navItems.push(menuItemIcons('Version: ' + _appVersion, sty, _icons_refresh))
    _navItems.push(menuItemIcons('Device', sty, _icons_platform))
    _navItems.push(menuItemIcons('Manifest', sty, _icons_manifest))

    if (showFcm) {
      // _navItems.push(menuItemFcm_subscribe())
      _navItems.push(menuItemFcm_test())
    }

    if (isSuperAdminDeveloper) {
      _navItems.push(menuItemIcon('Home', sty, 'home', handleBackToHome, 'blue'))
    }

    return _navItems
  }


  // const navMenu_auth = () => {

  //   let cn = 'inh oth'
  //   const sty = getItemStyle()
  //   const _navItems = []

  //   _navItems.push(menuItemIcon('auth: ' + app_metas?.auth?.appName, sty, 'user secret', null, 'red'))
  //   _navItems.push(menuItemIcon('fn: ' + app_metas?.functions?.appName, sty, 'code', null, 'red'))
  //   _navItems.push(menuItemIcon('fs: ' + app_metas?.firestore?.appName, sty, 'database', null, 'red'))
  //   _navItems.push(menuItemIcon('mess: ' + app_metas?.messaging?.appName, sty, 'send', null, 'red'))
  //   _navItems.push(menuItemIcon('fcmt: ' + fcmType, sty, 'mobile alternate', null, 'red'))
  //   _navItems.push(menuItemIcon('rt: ' + app_metas?.rtdb?.appName, sty, 'database', null, 'red'))
  //   _navItems.push(menuItemIcon('Scan', sty, 'qrcode', handleShowScanner, 'blue'))

  //   return _navItems.length > 0 ? <Menu borderless vertical fluid inverted={true} className={cn}>
  //     {_navItems}
  //   </Menu> : <div></div>
  // }

  const menuItems_options = () => {
    const sty = getItemStyle()
    const _navItems = []
    if (_allowCookieClearing) { _navItems.push(menuItemIcon('Clear Site Cookies', sty, 'erase', handleClearCookies, 'blue')) }
    if (allowPermissionsReset) { _navItems.push(menuItemIcon('Reset Permissions', sty, 'refresh', handleResetPermissions, 'blue')) }
    if (allowSendUserId) { _navItems.push(menuItemIcon('Send User Id', sty, 'send', handleSendUserId, 'blue')) }
    if (allowNotificationCheck) { _navItems.push(menuItemIcon('Check Notification Permission ', sty, 'check circle outline', handleShowNotificationCheck, 'blue')) }
    if (showHelp) { _navItems.push(menuItemIcon('Help', sty, 'help', handleShowHelp, 'blue')) }
    if ((allowBackToClient && eventKey)) { _navItems.push(menuItemIcon('Client', sty, 'handshake', handleBackToClient, 'blue')) }
    if (useOptionsDropdown) {
      return <React.Fragment>
        <Menu.Item>
          <Menu.Header onClick={() => handleShowStaticMis()}>{'Options'}<Icon name={showStaticMis ? 'caret down' : 'caret right'} style={{ float: 'right' }} /></Menu.Header>
        </Menu.Item>
        {showStaticMis && <Menu.Menu>
          {_navItems}
        </Menu.Menu>}
      </React.Fragment>
    } else {
      return _navItems
    }
  }

  const navMenu = () => {
    // showNotificationCheck && requestNotificationPermissionAgain()
    if (allowSidebarView === gEnums.viewPermissionTypes.allow) {
      let cn = 'inh oth'
      if (iconsLeft) { cn += ' icons-left' }
      const _menuItems = menuItems_nav()
      // return <ItemMenuSquares menuItems={_menuItems} imsType={_imsTypes.inline} />
      return _menuItems.length > 0 ? <Menu borderless vertical fluid inverted={true} className={cn}>
        {_menuItems}
      </Menu>
        : <div></div>
    }
    return <div></div>
  }

  const navMenu_device = () => {
    if (allowSidebarView === gEnums.viewPermissionTypes.allow) {
      let cn = 'inh oth'
      if (iconsLeft) { cn += ' icons-left' }
      const _menuItems_options = menuItems_options()
      const _menuItems = menuItems_device()
      return _menuItems.length > 0 ? <Menu borderless vertical fluid inverted={true} className={cn}>
        {_menuItems_options}
        {_menuItems}
        {isSuperAdminDeveloper && <Menu.Item>{_host}</Menu.Item>}
      </Menu>
        : <div></div>
    }
    return <div></div>
  }

  const handleScannedData = (data) => {
    appUsers_handlers.handleUpdate_tempAccess(data?.text)
    setShowScanner()
  }

  if (showNotifications) {
    return <AppNotificationsManager
      appNotificationType={appNotificationTypes.notifications}
      handleCancel={handleNotifications}
    />
  } else if (showScanner) {
    return <QrScan handleCancel={setShowScanner} handleScannedData={handleScannedData} />
  } else {
    return <React.Fragment>
      {navMenu()}
      {navMenu_device()}
      {/* {isSuperAdminDeveloper && navMenu_auth()} */}
    </React.Fragment>
  }
}

export default NavSideBottomMenu